import { constants as config } from '@config';
import searchOptionsTemplate from '../components/common/filter-search-options.hbs';
import BaseView from '../components/common/stock-component';
import AssetBank from './social-media-contents/assetbank';
import SearchView from '../search/search';
import { aiWrite as aiWriteFeature } from 'src/services/features';
import aiCtaTemplate from './ai-cta-template.hbs';

module.exports = BaseView.extend({
  CategoriesView: require('./patterns'),

  events: {
    ...BaseView.prototype.events,
    'click .ai-image-cta button': 'renderAIApp'
  },

  initialize: function (opts) {
    _.bindAll(this, 'search');
    opts = opts || {};
    this.isAssetBankCompany = opts.isAssetBankCompany;
    this.isKW = opts.isKW;
    this.assetBank = new AssetBank();
    opts.simplified = true;
    this.initSearch = opts.initSearch;

    BaseView.prototype.initialize.call(this, opts);

    this.renderAiImageBanner();
  },

  renderAiImageBanner: function () {
    if (!aiWriteFeature.isPreviewAllowed()) return;

    const userHaveAccess = INKIVE.Helpers.isDesygnerProject()
      ? INKIVE.UserInfoFactory.isProPaidUser()
      : INKIVE.UserInfoFactory.isBusinessUser() &&
      INKIVE.UserInfoFactory.hasContentPlan();

    const allowUserUpselling = INKIVE.C.FEATURE_FLAG?.users?.includes('allows_user_upselling');

    const showUpgradingPoint = !userHaveAccess && allowUserUpselling;

    const html = aiCtaTemplate({
      showIcon: showUpgradingPoint
    });
    const template = document.createElement('template');
    template.innerHTML = html.trim();

    const wrapper = document.querySelector('#tabImages > .tab-content .search-container');
    wrapper.insertAdjacentElement('beforebegin', template.content.firstChild);
  },

  selectSearchOptionEvent: function (event) {
    const $target = $(event.currentTarget);
    const $options = this.$searchOptions.find('> div');
    const $input = this.$searchOptions.siblings('input');

    if ($target.find('.crown-premium-option').length) {
      INKIVE.Helpers.displaySubscriptionModal('tool.versions.helper.description');
      return;
    }

    this.searchTitle = this.searchTitle || $input.attr('placeholder');

    if ($target.is($options)) {
      $options.removeClass('selected');
      $options.find('.desygner-icon-check').prependTo($target);
      $target.addClass('selected');

      const searchTitle = _.include(['kwls', 'mns'], $target.data('key'))
        ? INKIVE.TranslateHelper.translate('tool.search.kw_search_tooltip')
        : this.searchTitle;

      $input.attr('placeholder', searchTitle);
    }

    $options.closest('.search-container').children('input').focus();
  },

  search: function ($searchInput) {
    const $imageList = this.$el.find('.image-list');
    const $thumbnailWrapper = $imageList.find('.thumbnail-wrapper');

    $thumbnailWrapper.removeClass('thumbnail-wrapper').addClass('tab-content');
    $thumbnailWrapper.empty().css('height', '');

    this.$el.find('.categories-container').addClass('hidden');
    this.$el.parent().find('.search-options').hide();
    $imageList.find('.antiscroll-scrollbar').remove();
    $imageList.find('.tab-content').empty().removeData();

    const val = $searchInput ? $searchInput.val() : '';
    const query = val || this.getRandomSearchValue();
    INKIVE.Modal.loader(document.body);

    const initSearch = _.bind(function (opts) {
      opts = opts || {};

      this.searchView = this.searchView || new SearchView();
      this.searchView.initSearch($imageList, _.extend(opts, {
        query,
        type: 'image',
        callback: this.refreshAntiscroll
      }));
    }, this);

    if (this.$searchOptions &&
      this.$searchOptions.find('.providers-filter').find('input[name=assetbank]:checked').length) {
      this.assetBank.authenticate(true).then(_.bind(function () {
        this.assetBank.authenticated = true;
        initSearch({ legacy: 'assetbank' });
      }, this), function () {
        console.error('Error in authentication');
      });
    } else {
      initSearch();
    }
  },

  getSearchOptions: function (providers, types) {
    if (!this.$searchOptions) {
      this.$searchOptions = $(searchOptionsTemplate({
        isPremium: this.canUseFilters,
        isAssetBankCompany: this.isAssetBankCompany,
        isKW: this.isKW,
        providers,
        types,
        image: true,
        type: 'images-' + this.$el.siblings('.header-links').find('.active').attr('data-key')
      }));

      INKIVE.Helpers.initPopover(this.$searchOptions);
      this.$searchOptions.find('input#filter-option-sstk').trigger('click');
    }

    return this.$searchOptions;
  },

  refresh: function () {
    BaseView.prototype.refresh.call(this);

    const $thumbnailWrapper = this.$el.find('.image-list .thumbnail-wrapper');
    $thumbnailWrapper.data('masonry') && $thumbnailWrapper.masonry(config.sidebar.thumbnail.masonryConfig);
  },

  _render: function () {
    BaseView.prototype._render.call(this);

    this.initSearch && this.initSearch().then(() => this.search());
  }
});
